export const GET_CONSTANTS = "GET_CONSTANTS";
export const GET_CONSTANTS_SUCCESS = "GET_CONSTANTS_SUCCESS";
